import { sharedHeaders } from "../utils/constants"

const getActivities = {
  "type": "endpoint",
  "method": "get",
  "title": "Get Activities",
  "path": "/v1/activities",
  "description": "Get list of activities available for insurance purchases",
  "request": {
    "headers": [
      ...sharedHeaders
    ]
  },
  "responses": {
    "200": {
      "description": "Successful response",
      "content": {
        "application/json": {
          "schema": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ActivityDto"
            }
          }
        }
      }
    },
    "400": {
      "description": "Bad Request"
    },
    "401": {
      "description": "Unauthorized"
    },
    "500": {
      "description": "Internal Server Error"
    }
  },
  "components": {
    "schemas": {
      "ActivityDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "description": "Activity ID",
            "example": "puaQc2Y44zU16iiTeGob"
          },
          "title": {
            "type": "string",
            "description": "Localized activity title",
            "example": "Downhill skiing, snowboarding, other on-snow activities (snowshoeing, sledding...)"
          }
        },
        "required": [
          "id",
          "title"
        ]
      }
    }
  }
}

export { getActivities }
